import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useInlineEdit } from 'framework-asset-preview-lib/internal/shared/providers/InlineEditProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InlineEditPanelFooter() {
  const {
    isDraft,
    onReset,
    onSave,
    isLoading,
    hasErrors
  } = useInlineEdit();
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(Button, {
      disabled: isLoading || hasErrors || !isDraft,
      onClick: onSave,
      "data-test-id": "asset-preview-save-button",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.sidepanel.actions.save"
      })
    }), /*#__PURE__*/_jsx(Button, {
      disabled: !isDraft,
      "data-test-id": "asset-preview-cancel-button",
      onClick: onReset,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.sidepanel.actions.cancel"
      })
    })]
  });
}